






















































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import {
  SwModal,
  SwModalBody,
  SwModalFooter,
} from '@libs-uuif/shared/sw-modal';
import UUIFComponent from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';

const cssPrefix = 'saveConfigurationsModal';
@Component({
  components: {
    ...UUIFComponent,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwCheckbox,
    SwButton,
  },
})
export default class SaveConfigurartionsModal extends SwExtendedVue {
  @Prop({ required: true, type: Boolean, default: false })
  showSaveWidgetConfigurations: boolean;

  @Prop({ required: false, type: String, default: 'Save Dashboard - Confirmation' })
  modalTitle: string;

  modalWidth: string = '641px';
  cssPrefix = cssPrefix;
  enableApply: boolean = false;
  pickedValue: string = 'TENANT';

  onCloseModal() {
    const result = { mode: 'CLOSED' };
    this.$emit('saveDashboard', result);
  }

  saveDashboard() {
    let result = { mode: 'SAVE' };
    if (this.enableApply) {
      result = {
        mode: this.pickedValue ? this.pickedValue : 'SAVE',
      };
    }
    this.$emit('saveDashboard', result);
  }
}
